import script from "./EndorserView.vue?vue&type=script&setup=true&lang=js"
export * from "./EndorserView.vue?vue&type=script&setup=true&lang=js"

import "./EndorserView.vue?vue&type=style&index=0&id=41c51e2b&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c51e2b"]])

export default __exports__